<template>
  <div>
    <div class="search-wrapper">
      <div class="search-item">
        <span>地区：</span>
        <Select style="width:100px;" v-model="searchValue.area">
          <Option v-for="district in districts" :value="district.name"></Option>
        </Select>
      </div>
      <div class="search-item">
        <span>类型：</span>
        <Select style="width:150px;" v-model="searchValue.argumentType">
          <Option v-for="arguType in argumentTypes" :value="arguType.title"></Option>
        </Select>
      </div>
      <div class="search-item">
        <span>名称：</span>
        <Input style="width:200px;" v-model="searchValue.argumentName"></Input>
      </div>
      <Button type="primary" @click="search">搜索</Button>
      <slot name="extraBtn"></slot>
    </div>
    <Table :columns="columns" :data="argumentData" style="min-width:1200px;"></Table>
    <Page style="margin-top:5px;" :total="total" show-elevator :current="currentPage" @on-change="pageChange"></Page>
  </div>
</template>

<script>
import requestUrls from '@/lib/requestUrls'
import ajax from '@/lib/ajax'

export default {
  name: 'argumentLinkTable',
  props: {
    operateColumns: {
      type: Array,
      default() {
        return []
      }
    },
    extraQuery: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      argumentData: [],
      baseColumns: [
        {
          title: '地区',
          key: 'district',
          width: 65
        },
        {
          title: '编号',
          key: 'argumentFull',
          width: 80
        },
        {
          title: '名称',
          key: 'argumentName'
        },
        {
          title: '类型',
          key: 'argumentType',
          width: 130
        },
        {
          title: '会议时间',
          width: 108,
          render: (h, params) => {
            let time = '暂无'
            if (params.row.clMeetingRoomExt && params.row.clMeetingRoomExt.beginTime) {
              time = params.row.clMeetingRoomExt.beginTime.replace('T', ' ')
            }
            return h('div', time)
          }
        },
        {
          title: '备注',
          key: 'comment',
          width: 200,
          render: (h, params) => {
            return h('div', {
              attrs: {
                title: params.row.comment
              }
            }, params.row.comment)
          }
        }
      ],
      currentPage: 1,
      total: 0,
      argumentTypes: [
        {
          title: '论证（立项前）',
          linkRequired: false,
        },
        {
          title: '论证（立项后）',
          linkRequired: true,
        },
        {
          title: '质疑',
          linkRequired: true,
        },
        {
          title: '专家漏补',
          linkRequired: true,
        },
      ],
      searchValue: {
        area: '',
        argumentName: '',
        argumentType: ''
      },
      districts: [],
    }
  },
  created() {
    this.getPage()
    this.getDistrict()
  },
  computed: {
    columns() {
      return [...this.baseColumns, ...this.operateColumns]
    }
  },
  methods: {
    async getDistrict() {
      let rep = await ajax(requestUrls.CLDistrict.GetListWithoutRole)
      this.districts = []
      if (rep.data.success) {
        this.districts = rep.data.result.items
      }
    },
    async getPage(page = 1, { area = '', argumentName = '', argumentType = ''} = {}, { bidTimeLimit = '', flowExmineFilter = ''} = {}) {
      this.currentPage = page

      const areaFilter = area ? ` and district=="${area}"` : ''
      const nameFilter = argumentName ? ` and argumentName.contains("${argumentName}")` : ''
      const argumentTypeFilter = argumentType ? ` and argumentType=="${argumentType}"` : ''

      const bidTimeLimitFilter = bidTimeLimit ? bidTimeLimit : ''

      let filter = areaFilter + nameFilter + argumentTypeFilter + bidTimeLimitFilter
      filter = filter.slice(5)

      const flowLogReviewPerson = flowExmineFilter ? flowExmineFilter : ''

      let rep = await ajax.get(requestUrls.AbpArgument.GetPaged, {
        params: {
          flowLogReviewPerson: flowLogReviewPerson,
          filter: filter,
          sorting: 'creationTime desc',
          maxResultCount: 10,
          skipCount: (page - 1)*10
        }
      })
      this.argumentData = []
      if (rep.data.success) {
        this.argumentData = rep.data.result.items
        this.total = rep.data.result.totalCount
        this.$store.commit('expertOtherCount', rep.data.result.totalCount)
        this.$emit('argumentChange', this.argumentData)
      }
    },
    pageChange(page) {
      this.getPage(page, this.searchValue, this.extraQuery)
    },
    search() {
      this.getPage(1, this.searchValue, this.extraQuery)
    },
    refresh() {
      this.getPage(this.currentPage, this.searchValue, this.extraQuery)
    }
  }
}
</script>

<style lang="less" scoped>
.search-wrapper {
  display: flex;
  margin-bottom: 10px;
  flex-wrap: wrap;
  .search-item {
    margin-right: 10px;
  }
}
</style>
